'use es6';
/*
 * Persisted layout editor options.
 */

import { LAYOUT_EDITOR_OPTIONS_FETCH, LAYOUT_EDITOR_OPTIONS_SAVE, LAYOUT_EDITOR_OPTIONS_TOGGLE_WIDGET_SIDEBAR, LAYOUT_EDITOR_OPTIONS_SAVE_ACCORDION_STATE } from 'DesignData/actions/ActionTypes';
import * as client from 'DesignData/api/LayoutEditorOptions';
import { getPortalId, getUserId } from 'DesignData/selectors/auth';
import { createAsyncActions } from 'DesignData/lib/actions';
const getAsyncActions = createAsyncActions.bind(null, 'layoutEditorOptions');
/**
 * Fetch persisted layout editor options - for application startup.
 */

export function fetch() {
  return (dispatch, getState) => {
    const {
      request,
      receive,
      error
    } = fetch;
    const state = getState();
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    dispatch(request());
    return client.fetch(userId, portalId).then(data => dispatch(receive(data))).catch(err => dispatch(error(err)));
  };
}
Object.assign(fetch, getAsyncActions(LAYOUT_EDITOR_OPTIONS_FETCH));
/**
 * Save layout editor options.
 */

export function save() {
  return (dispatch, getState) => {
    const {
      request,
      receive,
      error
    } = save;
    const state = getState();
    const {
      layoutEditorOptions
    } = state;
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    dispatch(request());
    return client.save(userId, portalId, layoutEditorOptions).then(data => dispatch(receive(data))).catch(err => dispatch(error(err)));
  };
}
Object.assign(save, getAsyncActions(LAYOUT_EDITOR_OPTIONS_SAVE));
/**
 * Open/close widget sidebar.
 */

export function toggleWidgetSidebar() {
  return {
    type: LAYOUT_EDITOR_OPTIONS_TOGGLE_WIDGET_SIDEBAR
  };
}
/**
 * Save accordion open/close state.
 */

export function saveAccordionState(layoutId, key, isOpen = false, moduleId) {
  return {
    type: LAYOUT_EDITOR_OPTIONS_SAVE_ACCORDION_STATE,
    layoutId,
    moduleId,
    key,
    isOpen
  };
}